import React, { useState } from "react";
import { Plus } from "react-feather";
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";
import Swal from 'sweetalert2';


function AddStaff() {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("");
  const [selectedModules, setSelectedModules] = useState([]);

  const moduleMapping = {
    Dashboard: 1,
    Bookings: 2,
    Reports: 3,
    Settings: 4,
  };

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleModuleChange = (module) => {
    setSelectedModules((prevModules) =>
      prevModules.includes(module)
        ? prevModules.filter((m) => m !== module)
        : [...prevModules, module]
    );
  };

  const handleSubmit = async () => {
    try {
      const moduleIds = selectedModules.map((module) => moduleMapping[module]);
  
      const staffDetails = {
        name,
        email,
        password,
        phone,
        role,
        modules: moduleIds, // Send module IDs
      };
      console.log("Sent data:", staffDetails);
      // Send POST request to backend
      const response = await axios.post(`${baseurl}/add-staff`, staffDetails);
  
      console.log("Response from backend:", response.data);
  
      // Show success alert with SweetAlert2 and reload the page
      Swal.fire({
        icon: 'success',
        title: 'Staff Added Successfully!',
        text: 'The staff member has been added successfully.',
        confirmButtonText: 'OK',
      }).then(() => {
        window.location.reload();  // Reload the page after the user clicks OK
      });
  
      // Close modal and reset form
      setShowModal(false);
      setName("");
      setEmail("");
      setPassword("");
      setPhone("");
      setRole("");
      setSelectedModules([]);
    } catch (error) {
      console.error("Error adding staff:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Something went wrong. Please try again.',
      });
    }
  };
  

  return (
    <>
      {/* Add Staff Button */}
      <span className="btn3" onClick={handleOpenModal}>
        <Plus size={17} /> Add Staff
      </span>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title">Add Staff</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <form>
                  <div className="row g-1 text-start">
                    {/* Name */}
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">
                        Name
                      </label>
                      <input
                        type="text"
                        className="input1"
                        placeholder="Enter name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>

                    {/* Email */}
                    <div className="col-md-6">
                      <label className="text-dark mb-1 labelset2 font3">
                        Email
                      </label>
                      <input
                        type="email"
                        className="input1"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    {/* Password */}
                    <div className="col-md-6">
                      <label className="text-dark mb-1 labelset2 font3">
                        Password
                      </label>
                      <input
                        type="password"
                        className="input1"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>

                    {/* Phone */}
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">
                        Phone
                      </label>
                      <input
                        type="text"
                        className="input1"
                        placeholder="Enter phone number"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>

                    {/* Role Dropdown */}
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">
                        Role
                      </label>
                      <select
                        className="input1"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                      >
                        <option value="">Select Role</option>
                        <option value="Admin">Admin</option> 
                        <option value="Staff">Staff</option>
                      </select>
                    </div>

                    {/* Modules Checkboxes */}
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">
                        Modules
                      </label>
                      <div className="d-flex flex-wrap">
                        {Object.keys(moduleMapping).map((module) => (
                          <div key={module} className="form-check me-3">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={module}
                              checked={selectedModules.includes(module)}
                              onChange={() => handleModuleChange(module)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={module}
                            >
                              {module}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="text-end">
                    <button
                      type="button"
                      className="submit-btn mt-3"
                      onClick={handleSubmit}
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddStaff;
